var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _g, _path31, _path32, _path33, _path34, _path35, _g2, _path36, _g3, _path37, _g4, _path38, _g5, _path39, _g6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallposts({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 45,
    viewBox: "0 0 55 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1039_1696)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1039_1696",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -9,
    y: -13,
    width: 73,
    height: 74
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-8.52404 -12.402H63.6569V60.0071H-8.52404V-12.402Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1039_1696)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2876 37.22C51.2876 38.1127 50.5663 38.8362 49.6766 38.8362H5.46918C4.57948 38.8362 3.8581 38.1127 3.8581 37.22V8.67329C3.8581 7.78064 4.57948 7.05698 5.46918 7.05698H49.6766C50.5663 7.05698 51.2876 7.78064 51.2876 8.67329V37.22Z",
    fill: "#58595A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.27898 8.48243H49.8666V33.0139H5.27898V8.48243Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.27898 8.4825H49.8666V10.9851H5.27898V8.4825Z",
    fill: "#DBECED"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8581 34.8245V37.2201C3.8581 38.1128 4.57948 38.8364 5.46932 38.8364H49.6766C50.5663 38.8364 51.2876 38.1128 51.2876 37.2201V34.8245H3.8581Z",
    fill: "#ECECED"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.48538 9.73381C7.48538 10.104 7.18627 10.4042 6.81713 10.4042C6.44814 10.4042 6.14902 10.104 6.14902 9.73381C6.14902 9.36366 6.44814 9.06345 6.81713 9.06345C7.18627 9.06345 7.48538 9.36366 7.48538 9.73381Z",
    fill: "#CA5227"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.53874 9.73381C9.53874 10.104 9.23963 10.4042 8.87049 10.4042C8.5015 10.4042 8.20238 10.104 8.20238 9.73381C8.20238 9.36366 8.5015 9.06345 8.87049 9.06345C9.23963 9.06345 9.53874 9.36366 9.53874 9.73381Z",
    fill: "#FF9700"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6503 18.0611H23.4155V18.9094H30.6503V18.0611Z",
    fill: "#ABBCC6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7986 15.7643H20.2672V16.2062H33.7986V15.7643Z",
    fill: "#DBECED"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3871 14.2612H21.6788V14.703H32.3871V14.2612Z",
    fill: "#DBECED"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8668 33.0139H5.27913V20.7481H49.8668V33.0139Z",
    fill: "#DBECED"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7128 28.4749H7.69748V22.1834H13.7128V28.4749Z",
    fill: "white",
    stroke: "#9FD8FF",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0009 29.4747H7.69748V29.1534H13.0009V29.4747Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8262 30.2246H7.69733V29.9033H11.8262V30.2246Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7051 31.6082H7.69748V30.9856H10.7051V31.6082Z",
    fill: "#ABBCC6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9046 28.4749H18.8893V22.1834H24.9046V28.4749Z",
    fill: "white",
    stroke: "#9FD8FF",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1927 29.4747H18.8893V29.1534H24.1927V29.4747Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0182 30.2246H18.8893V29.9033H23.0182V30.2246Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8969 31.6082H18.8893V30.9856H21.8969V31.6082Z",
    fill: "#ABBCC6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0965 28.4749H30.0812V22.1834H36.0965V28.4749Z",
    fill: "white",
    stroke: "#9FD8FF",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3847 29.4747H30.0812V29.1534H35.3847V29.4747Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2101 30.2246H30.0812V29.9033H34.2101V30.2246Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0889 31.6082H30.0812V30.9856H33.0889V31.6082Z",
    fill: "#ABBCC6"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2885 28.4749H41.2732V22.1834H47.2885V28.4749Z",
    fill: "white",
    stroke: "#9FD8FF",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5766 29.4747H41.2732V29.1534H46.5766V29.4747Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4021 30.2246H41.2732V29.9033H45.4021V30.2246Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2808 31.6082H41.2732V30.9856H44.2808V31.6082Z",
    fill: "#ABBCC6"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00682 15.2094V17.0198L7.85726 16.1145L9.00682 15.2094Z",
    fill: "#DBECED"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0359 17.0197V15.2093L47.1854 16.1144L46.0359 17.0197Z",
    fill: "#DBECED"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1039_1696",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 8,
    width: 45,
    height: 26
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M5.27903 8.48243H49.8668V33.0139H5.27903V8.48243Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1039_1696)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.27903 8.48268L49.8667 33.0142V8.48268H5.27903Z",
    fill: "#ECECED"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M33.401 43.427H21.7447L22.776 38.8363H32.3697L33.401 43.427Z",
    fill: "#C5C5C7"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9153 43.4271H18.2304V44.6062H36.9153V43.4271Z",
    fill: "#ECECED"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M22.776 38.8363L33.3944 43.3975L32.3697 38.8363H22.776Z",
    fill: "#B0B1B3"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1039_1696",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 7,
    width: 49,
    height: 32
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M5.46926 7.05722C4.57955 7.05722 3.85818 7.78074 3.85818 8.6734V37.2201C3.85818 38.1126 4.57955 38.8364 5.46926 38.8364H49.6765C50.5663 38.8364 51.2877 38.1126 51.2877 37.2201V8.6734C51.2877 7.78074 50.5663 7.05722 49.6765 7.05722H5.46926Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1039_1696)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1039_1696",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 0,
    width: 26,
    height: 16
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4759 0.96153H54.9952V15.3618H29.4759V0.96153Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1039_1696)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.6095 0.961549H31.7689C31.5558 0.961549 31.3831 1.13475 31.3831 1.3485V9.64775L29.476 11.3841L31.3831 13.1203V13.504V14.9747C31.3831 15.1885 31.5558 15.3617 31.7689 15.3617H34.92H54.6095C54.8226 15.3617 54.9953 15.1885 54.9953 14.9747V9.72479V1.3485C54.9953 1.13475 54.8226 0.961549 54.6095 0.961549Z",
    fill: "#C5C5C7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1039_1696",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 17,
    width: 26,
    height: 14
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4759 17.5229H54.9952V30.7645H29.4759V17.5229Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1039_1696)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.6096 30.7642H31.7689C31.5559 30.7642 31.3832 30.591 31.3832 30.3772V23.2365L29.476 21.5003L31.3832 19.7641V19.3803V17.9095C31.3832 17.6959 31.5559 17.5226 31.7689 17.5226H34.9201H54.6096C54.8227 17.5226 54.9953 17.6959 54.9953 17.9095V23.1595V30.3772C54.9953 30.591 54.8227 30.7642 54.6096 30.7642Z",
    fill: "#C5C5C7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1039_1696",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 6,
    width: 26,
    height: 15
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0333328 6.41162H25.5527V20.8118H0.0333328V6.41162Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1039_1696)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.419221 6.41162H23.2599C23.473 6.41162 23.6456 6.58482 23.6456 6.79858V15.0978L25.5528 16.8342L23.6456 18.5704V18.954V20.4248C23.6456 20.6386 23.473 20.8118 23.2599 20.8118H20.1087H0.419221C0.206142 20.8118 0.0334854 20.6386 0.0334854 20.4248V15.1749V6.79858C0.0334854 6.58482 0.206142 6.41162 0.419221 6.41162Z",
    fill: "#C5C5C7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_1039_1696",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 22,
    width: 26,
    height: 16
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0156479 22.8894H25.5527V37.2551H0.0156479V22.8894Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_1039_1696)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5527 24.9523H21.497C20.2047 23.677 18.4326 22.8893 16.4767 22.8893H7.17586C3.22135 22.8893 0.0156479 26.1052 0.0156479 30.0722C0.0156479 34.0392 3.22135 37.255 7.17586 37.255H16.4767C20.4312 37.255 23.6369 34.0392 23.6369 30.0722C23.6369 29.5977 23.5898 29.1343 23.5022 28.6857L25.5527 24.9523Z",
    fill: "#C5C5C7"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_1039_1696",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -9,
    y: -13,
    width: 73,
    height: 74
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M-8.52404 -12.402H63.6569V60.0071H-8.52404V-12.402Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_1039_1696)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.6143 -0.000120817H31.7736C31.5605 -0.000120817 31.3879 0.173081 31.3879 0.386833V8.76312V9.46534V11.9471V12.5423V14.0131C31.3879 14.2268 31.5605 14.4 31.7736 14.4H34.9247H54.6143C54.8273 14.4 55 14.2268 55 14.0131V8.76312V0.386833C55 0.173081 54.8273 -0.000120817 54.6143 -0.000120817Z",
    fill: "#E30613"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5796 12.3333L29.4807 10.4225L31.5796 8.51164V12.3333Z",
    fill: "#E30613"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8897 6.8864H41.0344V7.72461H51.8897V6.8864Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4412 8.63203H41.0442V8.8313H49.4412V8.63203Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4412 10.9185H41.0442V11.1178H49.4412V10.9185Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8897 9.39423H41.0441V9.59351H51.8897V9.39423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5991 10.1564H41.0441V10.3557H45.5991V10.1564Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2331 5.55225C39.2331 7.15915 37.9346 8.46179 36.3328 8.46179C34.7311 8.46179 33.4325 7.15915 33.4325 5.55225C33.4325 3.94535 34.7311 2.64271 36.3328 2.64271C37.9346 2.64271 39.2331 3.94535 39.2331 5.55225Z",
    fill: "#A43C63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1068 5.42859C39.1068 7.03549 37.8083 8.33813 36.2064 8.33813C34.6047 8.33813 33.3062 7.03549 33.3062 5.42859C33.3062 3.82169 34.6047 2.51905 36.2064 2.51905C37.8083 2.51905 39.1068 3.82169 39.1068 5.42859Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2585 4.85157C37.2585 5.43432 36.7875 5.90686 36.2065 5.90686C35.6256 5.90686 35.1545 5.43432 35.1545 4.85157C35.1545 4.26882 35.6256 3.79628 36.2065 3.79628C36.7875 3.79628 37.2585 4.26882 37.2585 4.85157Z",
    fill: "#E30613"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2065 6.0991C35.4066 6.0991 34.7012 6.50401 34.282 7.12036H38.131C37.7118 6.50401 37.0064 6.0991 36.2065 6.0991Z",
    fill: "#E30613"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6143 16.5613H34.9247H31.7736C31.5605 16.5613 31.3879 16.7345 31.3879 16.9482V18.419V18.8028L29.4807 20.539L31.3879 22.2752V29.4159C31.3879 29.6295 31.5605 29.8029 31.7736 29.8029H54.6143C54.8273 29.8029 55 29.6295 55 29.4159V22.1982V16.9482C55 16.7345 54.8273 16.5613 54.6143 16.5613Z",
    fill: "#E30613"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9653 29.2235V22.0187L30.3399 20.5389L31.9653 19.0592V17.1405H54.4225V29.2235H31.9653Z",
    fill: "#F5F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8668 23.4477H41.0345V24.2859H49.8668V23.4477Z",
    fill: "#E30613"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4412 25.1934H41.0442V25.3927H49.4412V25.1934Z",
    fill: "#E30613"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4412 27.4801H41.0442V27.6793H49.4412V27.4801Z",
    fill: "#E30613"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8897 25.9556H41.0441V26.1549H51.8897V25.9556Z",
    fill: "#E30613"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5991 26.7178H41.0441V26.9171H45.5991V26.7178Z",
    fill: "#E30613"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1068 21.9899C39.1068 23.5968 37.8083 24.8994 36.2064 24.8994C34.6047 24.8994 33.3062 23.5968 33.3062 21.9899C33.3062 20.383 34.6047 19.0803 36.2064 19.0803C37.8083 19.0803 39.1068 20.383 39.1068 21.9899Z",
    fill: "#E30613"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2585 21.4128C37.2585 21.9956 36.7875 22.4681 36.2065 22.4681C35.6256 22.4681 35.1545 21.9956 35.1545 21.4128C35.1545 20.8301 35.6256 20.3576 36.2065 20.3576C36.7875 20.3576 37.2585 20.8301 37.2585 21.4128Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2065 22.6605C35.4066 22.6605 34.7012 23.0654 34.282 23.6818H38.131C37.7118 23.0654 37.0064 22.6605 36.2065 22.6605Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9653 17.1405H54.4225V29.2235",
    stroke: "#403F41",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3399 20.5389L31.9653 19.0592",
    stroke: "#403F41",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.419114 5.44995H23.2598C23.4728 5.44995 23.6455 5.62315 23.6455 5.83691V14.2132V14.9154V17.3972V17.9924V19.4631C23.6455 19.6769 23.4728 19.8501 23.2598 19.8501H20.1086H0.419114C0.206035 19.8501 0.0333786 19.6769 0.0333786 19.4631V14.2132V5.83691C0.0333786 5.62315 0.206035 5.44995 0.419114 5.44995Z",
    fill: "#E30613"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4538 17.7832L25.5527 15.8725L23.4538 13.9616V17.7832Z",
    fill: "#E30613"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4943 12.3364H10.1293V13.1746H16.4943V12.3364Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3933 16.568H10.1389V16.3687H17.3933V16.568Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3933 14.2814H10.1389V14.0821H17.3933V14.2814Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5087 15.8058H10.1389V15.6065H19.5087V15.8058Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9117 15.0436H10.1389V14.8443H18.9117V15.0436Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.20169 10.8785C8.20169 12.4854 6.90316 13.7881 5.30132 13.7881C3.69962 13.7881 2.40108 12.4854 2.40108 10.8785C2.40108 9.27164 3.69962 7.969 5.30132 7.969C6.90316 7.969 8.20169 9.27164 8.20169 10.8785Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.35334 10.3015C6.35334 10.8843 5.88243 11.3568 5.30138 11.3568C4.72047 11.3568 4.24941 10.8843 4.24941 10.3015C4.24941 9.71877 4.72047 9.24623 5.30138 9.24623C5.88243 9.24623 6.35334 9.71877 6.35334 10.3015Z",
    fill: "#E30613"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.30139 11.5492C4.50148 11.5492 3.79613 11.9541 3.3769 12.5704H7.22588C6.80665 11.9541 6.1013 11.5492 5.30139 11.5492Z",
    fill: "#E30613"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9381 24.0335H25.537L23.4382 27.8551L20.9381 24.0335Z",
    fill: "#E30613"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6212 29.1533C23.6212 25.1863 20.4155 21.9705 16.461 21.9705H7.16021C3.2057 21.9705 0 25.1863 0 29.1533C0 33.1203 3.2057 36.3362 7.16021 36.3362H16.461C20.4155 36.3362 23.6212 33.1203 23.6212 29.1533Z",
    fill: "#E30613"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5105 29.4323H10.1137V30.2705H18.5105V29.4323Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3777 33.6638H10.1233V33.4645H17.3777V33.6638Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3777 31.3773H10.1233V31.178H17.3777V31.3773Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4931 32.9017H10.1233V32.7025H19.4931V32.9017Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8961 32.1395H10.1233V31.9403H18.8961V32.1395Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.88284 25.6595H2.97814V30.5792H7.88284V25.6595Z",
    fill: "#C15D1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.73848 25.5147H2.83379V30.4344H7.73848V25.5147Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.33771 27.6871C6.33771 28.2699 5.8668 28.7424 5.28575 28.7424C4.70483 28.7424 4.23378 28.2699 4.23378 27.6871C4.23378 27.1044 4.70483 26.6319 5.28575 26.6319C5.8668 26.6319 6.33771 27.1044 6.33771 27.6871Z",
    fill: "#E30613"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.28574 28.9348C4.48583 28.9348 3.78048 29.3397 3.36125 29.9561H7.21023C6.791 29.3397 6.08565 28.9348 5.28574 28.9348Z",
    fill: "#E30613"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1039_1696"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 44.6063,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallposts);
export default __webpack_public_path__ + "static/media/wallposts.09816cbfb696b69b69732241a3242ace.svg";
export { ForwardRef as ReactComponent };